import { Box } from "@mui/material"


const Flying = ({ position = 'absolute', children, l, r, t, b, }) => {
    return (
        <Box sx={{
            position,
            left: l,
            right: r,
            top: t,
            bottom: b,

        }}>
            {children}
        </Box>
    )
}

export default Flying